import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const serviceIds = ['one-on-one', 'career-strategy', 'interview-prep'];

const serviceImages: Record<string, string> = {
  'one-on-one': 'https://readdy.ai/api/search-image?query=A%20modern%20home%20office%20setup%20with%20a%20laptop%20on%20a%20clean%20wooden%20desk%20displaying%20a%20video%20call%20interface%20with%20a%20friendly%20professional%20coach%20visible%20on%20the%20screen%20a%20notebook%20and%20coffee%20cup%20beside%20the%20laptop%20warm%20natural%20lighting%20from%20a%20nearby%20window%20with%20a%20small%20potted%20plant%20visible%20on%20the%20desk%20the%20scene%20conveys%20a%20comfortable%20virtual%20coaching%20session%20editorial%20photography%20style%20professional%20yet%20approachable%20atmosphere%20soft%20natural%20tones&width=800&height=800&seq=service-mentoring-online-10&orientation=squarish',
  'career-strategy': 'https://readdy.ai/api/search-image?query=Strategic%20career%20planning%20workspace%20with%20a%20large%20whiteboard%20filled%20with%20career%20roadmap%20diagrams%20and%20timeline%20markers%20a%20desk%20with%20neatly%20arranged%20documents%20and%20a%20laptop%20modern%20office%20environment%20with%20clean%20aesthetic%20natural%20lighting%20professional%20photography&width=800&height=800&seq=service-strategy-02&orientation=squarish',
  'interview-prep': 'https://readdy.ai/api/search-image?query=Modern%20bright%20office%20with%20a%20professional%20man%20in%20his%2030s%20reviewing%20a%20printed%20CV%20document%20at%20a%20clean%20desk%20with%20a%20laptop%20and%20coffee%20cup%20warm%20natural%20lighting%20from%20large%20windows%20professional%20yet%20relaxed%20atmosphere%20the%20man%20has%20short%20styled%20hair%20and%20wears%20a%20smart%20shirt%20editorial%20photography&width=800&height=800&seq=service-interview-male-11&orientation=squarish',
};

export default function ServicesSection() {
  const { t } = useTranslation();

  return (
    <section id="services" className="py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-14">
          <div className="lg:w-1/2">
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">
              {t('services.label')}
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              {t('services.title')}
              <br />
              <span className="italic text-primary-500">{t('services.subtitle')}</span>
            </h2>
          </div>
          <div className="lg:w-1/2">
            <p className="text-sm text-foreground-500 leading-relaxed max-w-lg lg:ml-auto">
              {t('services.intro')}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {serviceIds.map((id) => (
            <div
              key={id}
              className="group bg-white rounded-2xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-[260px] overflow-hidden">
                <img
                  src={serviceImages[id]}
                  alt={t(`services.items.${id}.title`)}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-primary-700 rounded-full mb-4">
                  {t(`services.items.${id}.category`)}
                </span>
                <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3 leading-snug">
                  {t(`services.items.${id}.title`)}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {t(`services.items.${id}.description`)}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-primary-500 hover:text-primary-600 border border-primary-200 hover:border-primary-300 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('home.viewServices')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}